import styled from 'styled-components';
import React, {FC} from 'react';

import {
  fontSizesMixins,
  fontWeights,
  mediaBreakpointDown,
  mediaBreakpointOnly,
  mediaBreakpointUp,
  palette,
  transition
} from '../../../../lib/styleVariables';
import {ImageTextBlock, ImageTextBlockProps} from '../../../molecules/textImageBlock';
import {StylableProps} from '../../../../lib/styleHelpers';
import {hiddenDesktopUpStyle, hiddenStyle} from '../../../../lib/responsiveClassNames';

const INITIAL_NUMBER_OF_ITEMS_SHOWN = 4;

interface ImageTextXSGridProps extends StylableProps {
  items: ImageTextBlockProps[];
  showMoreText?: string;
}

const StyledGridList = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const gridItemHiddenStyle = `
  ${mediaBreakpointDown('tablet')} {
    &:nth-child(n + ${INITIAL_NUMBER_OF_ITEMS_SHOWN + 1}) {
      display: none;
    }
  }
`;

const StyledGridItem = styled.div<{isHiddenOnMobile: boolean}>`
  display: flex;
  justify-content: center;
  padding-left: 5px;
  padding-right: 5px;

  ${mediaBreakpointUp('desktop')} {
    width: 33.3333%;

    &:not(:nth-child(-n + 3)) {
      margin-top: 55px;
    }
  }

  ${mediaBreakpointOnly('tablet')} {
    width: 50%;

    &:not(:nth-child(-n + 2)) {
      margin-top: 38px;
    }
  }

  ${mediaBreakpointDown('mobile')} {
    width: 100%;

    &:not(:first-child) {
      margin-top: 38px;
    }
  }
  ${props => (props.isHiddenOnMobile ? gridItemHiddenStyle : '')}
`;

const StyledShowMore = styled.div<{isVisible: boolean}>`
  width: 100%;
  margin-top: 32px;
  text-align: center;
  ${fontSizesMixins.text3()};
  color: ${palette.blue.base};

  ${mediaBreakpointDown('mobile')} {
    margin-top: 26px;
  }
  ${hiddenDesktopUpStyle}
  ${props => (props.isVisible ? hiddenStyle : '')}
`;

const StyledShowMoreText = styled.span`
  font-weight: ${fontWeights.bold};
  cursor: pointer;
  transition: ${transition.fast};

  &:hover {
    color: ${palette.black.base};
  }
`;

export const ImageTextXSGrid: FC<ImageTextXSGridProps> = props => {
  const {items, showMoreText, className} = props;
  const [gridVisibility, setGridVisibility] = React.useState(false);

  const elements = items.map((item: any) => (
    <StyledGridItem key={item.title} isHiddenOnMobile={!gridVisibility}>
      <ImageTextBlock className={className} size="xs" type="grid" {...item} />
    </StyledGridItem>
  ));
  const moreCount = items.length - INITIAL_NUMBER_OF_ITEMS_SHOWN;

  return (
    <StyledGridList>
      {elements}
      <StyledShowMore isVisible={gridVisibility}>
        <StyledShowMoreText
          onClick={() => {
            setGridVisibility(true);
          }}
        >
          {showMoreText} {`(${moreCount})`}
        </StyledShowMoreText>
      </StyledShowMore>
    </StyledGridList>
  );
};
